import { Paragraph, SinglePageHero } from '@okam/brand-ui/index'
import type { TPatternVariants } from '@okam/brand-ui/index'
import { WysiwygBlock } from '@okam/shared-ui/index'
import tw from 'twin.macro' /* eslint-disable-line */
import type { TFlexibleContent, TNewsLayout } from '@/components/flexible-content/types'
import { MainLayout } from '@/components/layout'
import { useFragment } from 'gql'
import type { PageQuery, SiteOptionsQuery, LastPostsQuery, Maybe, MainMenuFragment } from 'gql/graphql'
import { allMembersFragment } from 'query/fragments'
import FlexibleContentDispatcher from '../../../components/flexible-content/FlexibleContentDispatcher/FlexibleContentDispatcher'
import NewsLayout from '../../../components/flexible-content/NewsLayout/NewsLayout'

export interface TPageContent {
  pageProps: PageQuery & SiteOptionsQuery & LastPostsQuery
}

const PageContent = (props: TPageContent) => {
  const { pageProps } = props
  const { page, siteOptions, mainMenu } = pageProps
  const image = page?.featuredImage

  const allMembers = useFragment(allMembersFragment, pageProps.members)

  const bgPattern = page?.pageFields?.pagePattern ?? 'none'
  const imgSrc = image?.node?.sourceUrl ?? ''
  const imgAlt = image?.node?.altText ?? ''
  const imgWidth = image?.node?.mediaDetails?.width ?? undefined
  const imgHeight = image?.node?.mediaDetails?.height ?? undefined

  const okamContent = pageProps.page?.flexibleContent?.okamContent as Array<TFlexibleContent>

  return (
    <MainLayout
      siteOptionsProps={siteOptions}
      seo={page?.seo}
      allMembers={allMembers}
      menuItems={mainMenu as MainMenuFragment}
      variant="white"
      translatedUri={page?.translatedUri}
    >
      <header>
        <SinglePageHero
          title={page?.title ?? ''}
          imgSrc={imgSrc}
          imgAlt={imgAlt}
          imgWidth={imgWidth}
          imgHeight={imgHeight}
          imgSizes="(max-width: 640px) 640px, (max-width: 1024px) 1024px, (max-width: 1536px) 1536px, 100vw"
          bgPattern={bgPattern as TPatternVariants}
        >
          {page?.content && (
            <Paragraph as="h2" variant="p" tw="text-tertiary-2">
              <WysiwygBlock content={page?.content} />
            </Paragraph>
          )}
        </SinglePageHero>
      </header>
      {okamContent.map((content: TFlexibleContent, index: number) => {
        /* eslint-disable-next-line */
        const type = content?.__typename
        if (
          type === 'Expertise_Flexiblecontent_OkamContent_NewsLayout' ||
          type === 'Page_Flexiblecontent_OkamContent_NewsLayout'
        ) {
          const newsLayoutProps = { ...pageProps, ...content } as TNewsLayout & Maybe<LastPostsQuery>
          /* eslint-disable-next-line react/no-array-index-key */
          return <NewsLayout key={`page-flexibleContent-${content?.fieldGroupName}-${index}`} {...newsLayoutProps} />
        }
        return (
          /* eslint-disable react/no-array-index-key */
          <FlexibleContentDispatcher
            allMembers={allMembers}
            content={content}
            key={`page-flexibleContent-${content?.fieldGroupName}-${index}`}
          />
        )
      })}
    </MainLayout>
  )
}

export default PageContent
